module.exports = __webpack_public_path__ + "img/mapBackground.70f9f2fb.png";